import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  // orders
  placed: { label: "Placed", cls: "bg-sky-100 text-sky-700" },
  preparing: { label: "Preparing", cls: "bg-amber-100 text-amber-700" },
  ready: { label: "Ready", cls: "bg-emerald-100 text-emerald-700" },
  served: { label: "Served", cls: "bg-emerald-100 text-emerald-700" },
  completed: { label: "Completed", cls: "bg-stone-200 text-stone-600" },
  cancelled: { label: "Cancelled", cls: "bg-red-100 text-red-700" },
  // payment
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-700" },
  unpaid: { label: "Unpaid", cls: "bg-red-100 text-red-700" },
  // tables
  available: { label: "Available", cls: "bg-emerald-100 text-emerald-700" },
  occupied: { label: "Occupied", cls: "bg-orange-100 text-orange-700" },
  reserved: { label: "Reserved", cls: "bg-violet-100 text-violet-700" },
  billing: { label: "Billing", cls: "bg-sky-100 text-sky-700" },
  cleaning: { label: "Cleaning", cls: "bg-stone-200 text-stone-600" },
  // reservations
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-700" },
  confirmed: { label: "Confirmed", cls: "bg-sky-100 text-sky-700" },
  seated: { label: "Seated", cls: "bg-emerald-100 text-emerald-700" },
  no_show: { label: "No Show", cls: "bg-red-100 text-red-700" },
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-700" },
  // approval
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
  not_required: { label: "Auto", cls: "bg-stone-200 text-stone-600" },
  // bill
  open: { label: "Open", cls: "bg-stone-200 text-stone-600" },
  generated: { label: "Bill Ready", cls: "bg-sky-100 text-sky-700" },
  // source
  qr: { label: "QR", cls: "bg-violet-100 text-violet-700" },
  pos: { label: "POS", cls: "bg-orange-100 text-orange-700" },
  captain: { label: "Captain", cls: "bg-sky-100 text-sky-700" },
  phone: { label: "Phone", cls: "bg-amber-100 text-amber-700" },
};

export const StatusBadge = ({ status, className }) => {
  const s = MAP[status] || { label: status, cls: "bg-stone-100 text-stone-600" };
  return (
    <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold", s.cls, className)}
      data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
};
